module.exports = __webpack_public_path__ + "media/images/gift-thanks-title-ramen-df843d963e4d7f8e8125b6147829be4b.png";